import { Component, input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FloatLabel } from 'primeng/floatlabel';
import { Fluid } from 'primeng/fluid';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputMask } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'igx-text-input',
  imports: [
    InputTextModule,
    FloatLabel,
    IconFieldModule,
    InputIconModule,
    FormsModule,
    ReactiveFormsModule,
    Fluid,
    InputMask,
  ],
  templateUrl: './text-input.component.html',
})
export class TextInputComponent {
  public styleClass = input<string>();
  public icon = input<string>();
  public valueFormControl = input.required<FormControl>();
  public label = input.required<string>();
  public inputMask = input<string>();
  public maxLength = input<number>();

  public get isRequired(): boolean {
    return this.valueFormControl()?.hasValidator(Validators.required) ?? false;
  }
}
